import classNames from 'classnames';
import { FC, useCallback } from 'react';
import { RESTRICTION_ACCESS } from '~/constants/integrations';
import { localeStore } from '~/mobx/localesStore';
import { TBooleanInNumber } from '~/types/main';
import Input from '~/view/components/Controls/InputComponent/Input';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

interface IProps {
  vatIncluded: TBooleanInNumber;
  taxableDeliveryFee: TBooleanInNumber;
  vatAmount: string;
  vatAmountError?: string | null;
  vatIncludedAccess: RESTRICTION_ACCESS | undefined;
  vatAccess: RESTRICTION_ACCESS | undefined;
  onChangeVatIncluded: (status: TBooleanInNumber) => void;
  onChangeTaxableDeliveryFee: (status: TBooleanInNumber) => void;
  onChangeVatAmount: (value: string | undefined) => void;
}

export const TaxConfiguration: FC<IProps> = ({
  vatIncluded,
  taxableDeliveryFee,
  vatAmount,
  vatAmountError,
  vatIncludedAccess,
  vatAccess,
  onChangeVatIncluded,
  onChangeTaxableDeliveryFee,
  onChangeVatAmount,
}): JSX.Element => {
  const changeVatAmount = useCallback((value: string | undefined) => {
    onChangeVatAmount(Number(value) > 100 ? '100' : value);
  }, []);

  return (
    <div className="d-flex flex-column mt-4">
      <IntegrationManager setting={vatIncludedAccess} withTooltip>
        <div className="d-flex flex-row flex-1 align-items-center">
          <Switcher status={vatIncluded} onChange={onChangeVatIncluded} />
          <Text text="VAT_included" type={TEXT.SWITCHER_LABEL} />
        </div>
      </IntegrationManager>
      <div className="d-flex flex-row flex-1 align-items-center mt-4">
        <Switcher status={taxableDeliveryFee} onChange={onChangeTaxableDeliveryFee} />
        <Text text="Taxable_delivery_fee" type={TEXT.SWITCHER_LABEL} />
      </div>
      <IntegrationManager setting={vatAccess} withTooltip>
        <Input
          type="number"
          name="text"
          value={vatAmount}
          onChangeValue={changeVatAmount}
          prevComponent={<p className="px-4 family-medium text-size-16">{localeStore.t('vat_in_%')}</p>}
          placeholder={localeStore.t('Value')}
          maxLength={3}
          contentClassName={classNames('tax-configuration__input-wrapper mt-4', { 'input-error': vatAmountError })}
        />
      </IntegrationManager>
      {vatAmountError ? <Text text={vatAmountError} type={TEXT.ERROR} /> : null}
    </div>
  );
};
